import {authenticationRun} from './authentication.route';
import {DummyAuthenticationComponentConfig} from './component/dummy/dummyAuthenticaton';
import {InvitedUserProfileComponentConfig} from './component/invitedUserProfileView/invitedUserProfileView';
import {AuthenticationComponentConfig} from './component/loginpage/authenticaton';
import {PasswordChangedComponentConfig} from './component/passwordChangeView/passwordChangeView';
import {PasswordResetComponentConfig} from './component/passwordResetView/passwordResetView';
import {StartComponentConfig} from './component/startView/startView';
import {VerifyComponentConfig} from './component/verifyView/verifyView';
import AuthServiceRS from './service/AuthServiceRS.rest';
import HttpAuthInterceptor from './service/HttpAuthInterceptor';
import HttpBuffer from './service/HttpBuffer';

export const SerfWebAuthentication: angular.IModule =
    angular.module('dvbAngular.authentication', ['ngCookies', 'utf8-base64'])
        .run(authenticationRun)
        .service('HttpAuthInterceptor', HttpAuthInterceptor)
        .service('AuthServiceRS', AuthServiceRS)
        .service('AuthServiceRS', AuthServiceRS)
        .service('httpBuffer', HttpBuffer)
        .component('startView', new StartComponentConfig())
        .component('dummyAuthenticationView', new DummyAuthenticationComponentConfig())
        .component('passwordResetView', new PasswordResetComponentConfig())
        .component('passwordChangeView', new PasswordChangedComponentConfig())
        .component('invitedUserProfileView', new InvitedUserProfileComponentConfig())
        .component('verifyView', new VerifyComponentConfig())
        .component('authenticationView', new AuthenticationComponentConfig());



// WEBPACK FOOTER //
// ./src/app/authentication/authentication.module.ts